import { render, staticRenderFns } from "./judge.vue?vue&type=template&id=198c1c9f&scoped=true&lang=html&"
import script from "./judge.vue?vue&type=script&lang=js&"
export * from "./judge.vue?vue&type=script&lang=js&"
import style0 from "./judge.vue?vue&type=style&index=0&id=198c1c9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c1c9f",
  null
  
)

export default component.exports